import { updateTimeEntry, createTimeEntry } from './graphql';

export const types = {
  INIT: 'forms/timeEntry/INIT',
  SET_API_ERROR_MESSAGE: 'forms/timeEntry/SET_API_ERROR_MESSAGE',
};

export const dispatchInitFormData = (timeEntry) => {
  return {
    type: types.INIT,
    data: timeEntry,
  };
};

export const dispatchSetAPIErrorMessage = (errorMessage) => {
  return {
    type: types.SET_API_ERROR_MESSAGE,
    APIErrorMessage: errorMessage,
  };
};

export const dispatchCreateOrUpdateTimeEntry = (
  onSuccess,
  originaTimeEntryId,
  originalTimeEntryKey,
  newtimeEntryValues,
  supervisorId,
  userId,
  timesheetOriginDate,
) => {
  return async (dispatch, getState, { client }) => {
    try {
      if (originaTimeEntryId) {
        await updateTimeEntry(
          client,
          originaTimeEntryId,
          originalTimeEntryKey,
          newtimeEntryValues,
          supervisorId,
          userId,
          timesheetOriginDate,
        );
      } else {
        await createTimeEntry(
          client,
          newtimeEntryValues,
          supervisorId,
          userId,
          timesheetOriginDate,
        );
      }
      dispatch(dispatchSetAPIErrorMessage(null));
      onSuccess();
    } catch (error) {
      if (error.graphQLErrors) {
        const errorObj = error.graphQLErrors[0];
        const errorMessage = `${errorObj.message} - ${errorObj.details}`;
        dispatch(dispatchSetAPIErrorMessage(errorMessage));
      }
    }
  };
};
